module.exports = __webpack_public_path__ + "blissweb-lt.3a4445e73093431a7833.woff";


//////////////////
// WEBPACK FOOTER
// ./src/assets/css/fonts/BlissWeb-Lt/blissweb-lt.woff
// module id = 477
// module chunks = 5